import React from 'react';

const CreateStaffModal = ({
  newStaffFirstName,
  setNewStaffFirstName,
  newStaffLastName,
  setNewStaffLastName,
  newStaffPhone,
  setNewStaffPhone,
  newStaffPassword,
  setNewStaffPassword,
  newStaffSMSList,
  setNewStaffSMSList,
  formatAsPhonePartial,
  onCreate,
  onCancel,
}) => {
  const isPhoneValid = ('' + newStaffPhone).replace(/\D/g, '').length === 10;
  const isValid =
    newStaffFirstName.trim() &&
    newStaffLastName.trim() &&
    isPhoneValid &&
    newStaffPassword.trim();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg w-[90%] max-w-md text-black">
        <h2 className="text-2xl font-bold mb-4">Create Staff User</h2>
        <div className="flex flex-col gap-4 mb-4">
          <div className="flex flex-col">
            <label className="text-sm font-semibold">First Name</label>
            <input
              type="text"
              value={newStaffFirstName}
              onChange={e => setNewStaffFirstName(e.target.value)}
              className="border border-gray-300 rounded px-2 py-1"
              placeholder="Enter first name"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Last Name</label>
            <input
              type="text"
              value={newStaffLastName}
              onChange={e => setNewStaffLastName(e.target.value)}
              className="border border-gray-300 rounded px-2 py-1"
              placeholder="Enter last name"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Phone Number</label>
            <input
              type="text"
              value={formatAsPhonePartial(newStaffPhone)}
              onChange={e => {
                const onlyDigits = e.target.value.replace(/\D/g, '');
                if (onlyDigits.length <= 10) setNewStaffPhone(onlyDigits);
              }}
              onPaste={e => {
                e.preventDefault();
                const paste = (e.clipboardData || window.clipboardData).getData('text');
                const onlyDigits = paste.replace(/\D/g, '').slice(0, 10);
                setNewStaffPhone(onlyDigits);
              }}
              className="border border-gray-300 rounded px-2 py-1"
              placeholder="(123) 456-7890"
            />
            {!isPhoneValid && newStaffPhone && (
              <div className="text-xs text-red-600 mt-1">
                Phone must be 10 digits.
              </div>
            )}
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Password</label>
            <input
              type="text"
              value={newStaffPassword}
              onChange={e => setNewStaffPassword(e.target.value)}
              className="border border-gray-300 rounded px-2 py-1"
              placeholder="Enter password"
            />
          </div>
          <div className="flex items-center gap-2">
            <input
              id="sms-list-checkbox"
              type="checkbox"
              checked={newStaffSMSList}
              onChange={e => setNewStaffSMSList(e.target.checked)}
              className="w-4 h-4"
            />
            <label htmlFor="sms-list-checkbox" className="text-sm">
              SMS List (receive text messages when Clients create/cancel/reschedule appointments or message JMJ)
            </label>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="bg-gray-300 hover:bg-gray-400 text-black font-semibold px-4 py-2 rounded"
          >
            Cancel
          </button>
          <button
            onClick={onCreate}
            disabled={!isValid}
            className={`font-semibold px-4 py-2 rounded transition ${
              isValid
                ? 'bg-JMJ hover:bg-JMJGray text-white'
                : 'bg-gray-200 text-gray-500 cursor-not-allowed'
            }`}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateStaffModal;
